module.exports = __webpack_public_path__ + "img/sally2.4b45a18e.png";